import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import DHPic from "../../images/Dr-haiel3.png";

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
  avt: {
    marginBottom: 20,
    "&:before": {
      backgroundImage: `url(${DHPic})`,
      backgroundSize: "30px 30px",
      backgroundRepeat: "no-repeat",
      content: '""',
      position: "absolute",
      left: 10,
      width: 30,
      height: 30,
    },
  },
  bot: {
    maxWidth: 345,
  },
});

const all_specialties = [
  "ADDICTION MEDICINE",
  "ADULT CONGENITAL HEART DISEASE (ACHD)",
  "ADVANCED HEART FAILURE AND TRANSPLANT CARDIOLOGY",
  "ALLERGY/IMMUNOLOGY",
  "ANESTHESIOLOGY",
  "ANESTHESIOLOGY ASSISTANT",
  "CARDIAC ELECTROPHYSIOLOGY",
  "CARDIAC SURGERY",
  "CARDIOVASCULAR DISEASE (CARDIOLOGY)",
  "CERTIFIED CLINICAL NURSE SPECIALIST (CNS)",
  "CERTIFIED NURSE MIDWIFE (CNM)",
  "CERTIFIED REGISTERED NURSE ANESTHETIST (CRNA)",
  "CHIROPRACTIC",
  "CLINICAL PSYCHOLOGIST",
  "CLINICAL SOCIAL WORKER",
  "COLORECTAL SURGERY (PROCTOLOGY)",
  "CRITICAL CARE (INTENSIVISTS)",
  "DENTIST",
  "DERMATOLOGY",
  "DIAGNOSTIC RADIOLOGY",
  "EMERGENCY MEDICINE",
  "ENDOCRINOLOGY",
  "FAMILY PRACTICE",
  "GASTROENTEROLOGY",
  "GENERAL PRACTICE",
  "GENERAL SURGERY",
  "GERIATRIC MEDICINE",
  "GERIATRIC PSYCHIATRY",
  "GYNECOLOGICAL ONCOLOGY",
  "HAND SURGERY",
  "HEMATOLOGY",
  "HEMATOLOGY/ONCOLOGY",
  "HEMATOPOIETIC CELL TRANSPLANTATION AND CELLULAR THERAPY",
  "HOSPICE/PALLIATIVE CARE",
  "HOSPITALIST",
  "INFECTIOUS DISEASE",
  "INTERNAL MEDICINE",
  "INTERVENTIONAL CARDIOLOGY",
  "INTERVENTIONAL PAIN MANAGEMENT",
  "INTERVENTIONAL RADIOLOGY",
  "MAXILLOFACIAL SURGERY",
  "MEDICAL GENETICS AND GENOMICS",
  "MEDICAL ONCOLOGY",
  "MEDICAL TOXICOLOGY",
  "MICROGRAPHIC DERMATOLOGIC SURGERY (MDS)",
  "NEPHROLOGY",
  "NEUROLOGY",
  "NEUROPSYCHIATRY",
  "NEUROSURGERY",
  "NUCLEAR MEDICINE",
  "NURSE PRACTITIONER",
  "OBSTETRICS/GYNECOLOGY",
  "OCCUPATIONAL THERAPY",
  "OPHTHALMOLOGY",
  "OPTOMETRY",
  "ORAL SURGERY",
  "ORTHOPEDIC SURGERY",
  "OSTEOPATHIC MANIPULATIVE MEDICINE",
  "OTOLARYNGOLOGY",
  "PAIN MANAGEMENT",
  "PATHOLOGY",
  "PEDIATRIC MEDICINE",
  "PERIPHERAL VASCULAR DISEASE",
  "PHYSICAL MEDICINE AND REHABILITATION",
  "PHYSICAL THERAPY",
  "PHYSICIAN ASSISTANT",
  "PLASTIC AND RECONSTRUCTIVE SURGERY",
  "PODIATRY",
  "PREVENTIVE MEDICINE",
  "PSYCHIATRY",
  "PULMONARY DISEASE",
  "QUALIFIED AUDIOLOGIST",
  "QUALIFIED SPEECH LANGUAGE PATHOLOGIST",
  "RADIATION ONCOLOGY",
  "REGISTERED DIETITIAN OR NUTRITION PROFESSIONAL",
  "RHEUMATOLOGY",
  "SLEEP MEDICINE",
  "SPORTS MEDICINE",
  "SURGICAL ONCOLOGY",
  "THORACIC SURGERY",
  "UNDEFINED NON-PHYSICIAN TYPE (SPECIFY)",
  "UNDEFINED PHYSICIAN TYPE (SPECIFY)",
  "UNDERSEA AND HYPERBARIC MEDICINE",
  "UROLOGY",
  "VASCULAR SURGERY",
];

const SpecialtyInput = ({ content, onUserInput, isLastMessage }) => {
  const classes = useStyles();

  const [displayForm, setDisplayForm] = React.useState("block");
  const [dkw, setDkw] = React.useState("");
  const [dkwsBeginWithInput, setDkwsBeginWithInput] = React.useState([]);

  const findSpecialtiesWithString = (stringInput) => {
    return all_specialties.filter((item) => {
      return item.includes(stringInput.toUpperCase());
    });
  };

  const handleUserInput = async (e) => {
    if (e.target.value.length > 2) {
      const result = findSpecialtiesWithString(e.target.value);
      setDkwsBeginWithInput([...result]);
    }
  };

  const handleSubmit = () => {
    setDisplayForm("none");
    onUserInput("user submit", `${dkw}`);
  };

  return (
    <Fragment>
      <div className={classes.avt}>_</div>
      <Card
        className={(classes.root, classes.bot)}
        style={{
          marginBottom: "20px",
          backgroundColor: "#E3F5F7",
        }}
      >
        <CardContent>
          <Typography variant="h5" component="h2" style={{ fontSize: "1rem" }}>
            {" "}
            {content}{" "}
          </Typography>{" "}
        </CardContent>{" "}
        <div style={{ display: displayForm }}>
          <FormControl className={classes.margin}>
            <Autocomplete
              id="combo-box-demo"
              options={dkwsBeginWithInput}
              style={{ width: 250, marginLeft: 8, marginBottom: 16 }}
              renderInput={(params) => (
                <TextField {...params} label="Specialty" variant="outlined" />
              )}
              onInputChange={handleUserInput}
              onChange={(e, newValue) => {
                setDkw(newValue);
              }}
            />{" "}
          </FormControl>{" "}
          <FormControl className={classes.margin}>
            <Button
              style={{ marginLeft: 8, marginBottom: 16 }}
              variant="contained"
              onClick={handleSubmit}
            >
              Submit{" "}
            </Button>{" "}
          </FormControl>{" "}
        </div>{" "}
      </Card>
    </Fragment>
  );
};
SpecialtyInput.propTypes = {
  content: PropTypes.string.isRequired,
  onUserInput: PropTypes.func.isRequired,
  isLastMessage: PropTypes.bool.isRequired,
};

export default SpecialtyInput;



// WEBPACK FOOTER //
// ./src/components/SpecialtyInput/SpecialtyInput.js